import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import HeaderMenu from './HeaderMenu';

import { App } from '@meronex/app';
import TopHeader from './TopHeader';
import Filter from '../../common/Filter';


const useStyles = makeStyles((theme) => ({
  container: {},
}));

function View(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const {
    children,
    viewId,
    activeView,
    showMenu,
    icon,
    style,
    menuStyle,
    title,
    subtitle,
    filterProps,
    itemsCount,
    itemsUnit,
    onTitleDropdownClick,
    onOpen,
    onRefresh,
    onBack,
    actionLabel,
    onAction,
    subHeader,
    sidePanel,
  } = props;

  const [open, setOpen] = React.useState(false);

  // Keep onRefresh in a ref so event listeners always use the latest version
  const onRefreshRef = React.useRef(onRefresh);
  React.useEffect(() => { onRefreshRef.current = onRefresh; }, [onRefresh]);

  React.useEffect(() => {
    if (activeView === viewId) {
      setOpen(true);
    } else {
      setTimeout(() => {
        setOpen(false);
      }, 500);
    }
  }, [activeView]);

  React.useEffect(() => {
    App.eventsManager.on('event-user-loaded', viewId, () => {});
    App.eventEmitter.on('event-item-type-update', () => {
      onRefreshRef.current(() => {});
    });
    // event-refresh-views still used by EditStoreDialog
    App.eventsManager.on('event-refresh-views', viewId, () => {
      onRefreshRef.current(() => {});
    });
    return () => {
      App.eventsManager.removeListener('event-user-loaded', viewId);
      App.eventsManager.removeListener('event-refresh-views', viewId);
    };
  }, []);

  React.useEffect(() => {
    if (open) {
      onOpen();
    }
  }, [open]);

  const topHeaderRef = React.useRef();
  const filterRef = React.useRef();

  if (activeView !== viewId) {
    return null;
  }
  const contentStyle = Object.assign(
    {
      touchAction: 'pan-y',
      overflowX: 'hidden',
      position: 'relative',
    },
    style
  );

  return (
    <div className={'view-container'} style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        {title && (
          <div
            style={{
              padding: '0 20px',
              height: '68px',
              display: 'flex',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 5,
              backgroundColor: isDark ? '#1e1e22' : '#fff',
              borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
              boxSizing: 'border-box',
            }}>
            <TopHeader
              ref={topHeaderRef}
              icon={icon}
              activeView={activeView}
              title={title}
              onTitleDropdownClick={onTitleDropdownClick}
              subtitle={subtitle}
              showMenu={showMenu}
              menuStyle={menuStyle}
              itemsCount={itemsCount}
              itemsUnit={itemsUnit}
              onRefresh={onRefresh}
              onBack={onBack}
              actionLabel={actionLabel}
              onAction={onAction}
            />
          </div>
        )}
      </div>
      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          {subHeader}
          {filterProps && (
            <div style={{ padding: '8px 20px' }}>
              <div style={{
                backgroundColor: isDark ? '#2a2a2e' : '#fff',
                borderRadius: '16px',
                border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
                padding: '12px 16px',
              }}>
                <Filter ref={filterRef} {...filterProps} />
              </div>
            </div>
          )}
          <div style={contentStyle}>
            {children}
          </div>
        </div>
        {sidePanel}
      </div>
    </div>
  );
}

View.propTypes = {
  children: PropTypes.node,
  viewId: PropTypes.string,
  activeView: PropTypes.string,
  showMenu: PropTypes.bool,
  menuStyle: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  itemsCount: PropTypes.number,
  itemsUnit: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
  filterProps: PropTypes.object,
  onOpen: PropTypes.func,
  onTitleDropdownClick: PropTypes.func,
  onRefresh: PropTypes.func,
  onBack: PropTypes.func,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  subHeader: PropTypes.node,
  sidePanel: PropTypes.node,
};

View.defaultProps = {
  onRefresh: () => {},
  onOpen: () => {},
  menuStyle: {},
};

export default View;
